
    import './styles.scoped.css';
    export default {
  "drawer": "awsui_drawer_1r9lg_1mr13_190",
  "refresh": "awsui_refresh_1r9lg_1mr13_190",
  "animating": "awsui_animating_1r9lg_1mr13_204",
  "preference-icon--layout-border": "awsui_preference-icon--layout-border_1r9lg_1mr13_227",
  "preference-icon--layout-background": "awsui_preference-icon--layout-background_1r9lg_1mr13_231",
  "preference-icon--layout-header": "awsui_preference-icon--layout-header_1r9lg_1mr13_234",
  "preference-icon--border": "awsui_preference-icon--border_1r9lg_1mr13_237",
  "preference-icon--primary-button": "awsui_preference-icon--primary-button_1r9lg_1mr13_241",
  "preference-icon--secondary": "awsui_preference-icon--secondary_1r9lg_1mr13_244",
  "preference-icon--disabled-element": "awsui_preference-icon--disabled-element_1r9lg_1mr13_247",
  "preference-icon--separator": "awsui_preference-icon--separator_1r9lg_1mr13_250",
  "preference-icon--focus-text": "awsui_preference-icon--focus-text_1r9lg_1mr13_253",
  "preference-icon-refresh--layout-top": "awsui_preference-icon-refresh--layout-top_1r9lg_1mr13_257",
  "preference-icon-refresh--layout-main": "awsui_preference-icon-refresh--layout-main_1r9lg_1mr13_260",
  "preference-icon-refresh--primary": "awsui_preference-icon-refresh--primary_1r9lg_1mr13_263",
  "preference-icon-refresh--disabled": "awsui_preference-icon-refresh--disabled_1r9lg_1mr13_266",
  "preference-icon-refresh--column-header": "awsui_preference-icon-refresh--column-header_1r9lg_1mr13_269",
  "preference-icon-refresh--window": "awsui_preference-icon-refresh--window_1r9lg_1mr13_272",
  "preference-icon-refresh--secondary": "awsui_preference-icon-refresh--secondary_1r9lg_1mr13_276",
  "preference-icon-refresh--default": "awsui_preference-icon-refresh--default_1r9lg_1mr13_279",
  "preference-icon-refresh--separator": "awsui_preference-icon-refresh--separator_1r9lg_1mr13_282",
  "preference-icon-refresh--input-default": "awsui_preference-icon-refresh--input-default_1r9lg_1mr13_285",
  "preference-icon-refresh--heading": "awsui_preference-icon-refresh--heading_1r9lg_1mr13_288",
  "resize-active": "awsui_resize-active_1r9lg_1mr13_293",
  "resize-side": "awsui_resize-side_1r9lg_1mr13_299",
  "resize-bottom": "awsui_resize-bottom_1r9lg_1mr13_302",
  "root": "awsui_root_1r9lg_1mr13_307",
  "preferences-button": "awsui_preferences-button_1r9lg_1mr13_318",
  "close-button": "awsui_close-button_1r9lg_1mr13_322",
  "drawer-closed": "awsui_drawer-closed_1r9lg_1mr13_333",
  "drawer-content-side": "awsui_drawer-content-side_1r9lg_1mr13_338",
  "drawer-content-bottom": "awsui_drawer-content-bottom_1r9lg_1mr13_358",
  "position-bottom": "awsui_position-bottom_1r9lg_1mr13_367",
  "position-side": "awsui_position-side_1r9lg_1mr13_394",
  "slider": "awsui_slider_1r9lg_1mr13_400",
  "slider-side": "awsui_slider-side_1r9lg_1mr13_429",
  "slider-wrapper-bottom": "awsui_slider-wrapper-bottom_1r9lg_1mr13_434",
  "slider-wrapper-side": "awsui_slider-wrapper-side_1r9lg_1mr13_445",
  "open-button": "awsui_open-button_1r9lg_1mr13_456",
  "open-button-side": "awsui_open-button-side_1r9lg_1mr13_460",
  "slider-icon": "awsui_slider-icon_1r9lg_1mr13_467",
  "slider-icon-bottom": "awsui_slider-icon-bottom_1r9lg_1mr13_473",
  "slider-icon-side": "awsui_slider-icon-side_1r9lg_1mr13_476",
  "pane-header-wrapper-bottom": "awsui_pane-header-wrapper-bottom_1r9lg_1mr13_480",
  "drawer-mobile": "awsui_drawer-mobile_1r9lg_1mr13_490",
  "drawer-disable-content-paddings": "awsui_drawer-disable-content-paddings_1r9lg_1mr13_493",
  "content-bottom": "awsui_content-bottom_1r9lg_1mr13_501",
  "pane-bottom-center-align": "awsui_pane-bottom-center-align_1r9lg_1mr13_512",
  "pane-bottom-content-nav-padding": "awsui_pane-bottom-content-nav-padding_1r9lg_1mr13_517",
  "pane-bottom-content-tools-padding": "awsui_pane-bottom-content-tools-padding_1r9lg_1mr13_521",
  "content-bottom-max-width": "awsui_content-bottom-max-width_1r9lg_1mr13_525",
  "content-side": "awsui_content-side_1r9lg_1mr13_530",
  "pane-header-wrapper-side": "awsui_pane-header-wrapper-side_1r9lg_1mr13_541",
  "pane-content-wrapper-side": "awsui_pane-content-wrapper-side_1r9lg_1mr13_544",
  "header": "awsui_header_1r9lg_1mr13_549",
  "header-text": "awsui_header-text_1r9lg_1mr13_558",
  "header-divider": "awsui_header-divider_1r9lg_1mr13_568",
  "header-actions": "awsui_header-actions_1r9lg_1mr13_574",
  "divider": "awsui_divider_1r9lg_1mr13_582"
};
  